import * as supervisionActions from './supervision-reducer.constants'

export const supervisionInitialState = {
  //General data:
  data: [],
  //Loading state and meta-data:
  search: {},
  pagination: { totalSolicitudes: 0 },
  loading: false,
  msLoaded: false,
  error: false,
  //Selected object
  selection_id: null,
  tableSelection: [],
}

export const supervisionReducer = (state, { type, payload }) => {
  switch (type) {
    case supervisionActions.SET_SUPERVISION_DATA:
      return {
        ...state,
        data: payload.data,
        search: payload.search,
        pagination: payload.pagination,
        loading: false,
        msLoaded: Date.now(),
      }
    case supervisionActions.SUPERVISION_LOAD:
      return {
        ...state,
        error: false,
        loading: true,
      }
    case supervisionActions.SUPERVISION_FAILURE:
      return {
        ...state,
        error: payload,
        loading: false,
        msLoaded: true,
      }
    case supervisionActions.SUPERVISION_APP_DETAIL_LOAD:
      return {
        ...state,
        application: payload,
        // isCertificate: payload.isCertificate,
        detailLoading: false,
      }
    case supervisionActions.SET_DETAIL_LOADING:
      return {
        ...state,
        detailError: false,
        detailLoading: true,
      }
    case supervisionActions.SET_DETAIL_FAILURE:
      return {
        ...state,
        detailError: true,
        detailLoading: false,
      }
    case supervisionActions.UPDATE_SUPERVISED_APPLICATION:
      return {
        ...state,
        loading: false,
        data: state.data.map((item) => (item.id === payload.id ? { ...item, ...payload } : item)),
      }
    case supervisionActions.SELECT_SUPERVISED_APPLICATION:
      return {
        ...state,
        selection_id: payload,
      }
    case supervisionActions.SET_IS_CERTIFICATE:
      return {
        ...state,
        certificate: payload,
      }
    case supervisionActions.UPDATE_TABLE_SELECTION:
      return {
        ...state,
        tableSelection: payload,
      }
    default:
      throw new Error('unknown action')
  }
}
